import styled, { css } from 'styled-components';
import {
  AVATAR_STATUS_ONLINE,
  AVATAR_STATUS_OFFLINE,
  AVATAR_STATUS_AWAY,
  type AvatarStatus,
} from './Avatar.constants';

const STATUS_COLORS: Record<AvatarStatus, string> = {
  [AVATAR_STATUS_ONLINE]: '#8CD88C',
  [AVATAR_STATUS_AWAY]: '#F2B547',
  [AVATAR_STATUS_OFFLINE]: '#9A99A6',
};

export interface WrapperProps {
  $size: number;
  $isInteractive?: boolean;
  $isActive?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: visible;
  flex-shrink: 0;

  ${({ $size }) => css`
    width: ${$size}px;
    height: ${$size}px;
  `}

  ${({ theme: { colors = {} } }) => css`
    background-color: color-mix(
      in oklch,
      ${colors.primary ?? '#88f'} 22%,
      ${colors.surfaceContainer ?? '#222'}
    );
    color: ${colors.onSurface ?? '#fff'};
  `}

  ${({ $isInteractive, theme: { colors = {} } }) =>
    $isInteractive &&
    css`
      border: 0;
      padding: 0;
      cursor: pointer;
      transition:
        transform 160ms ease,
        box-shadow 160ms ease;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 0 2px
          color-mix(in oklch, ${colors.primary ?? '#88f'} 40%, transparent);
      }

      &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px ${colors.primary ?? '#88f'};
      }
    `}

  ${({ $isActive, theme: { colors = {} } }) =>
    $isActive &&
    css`
      box-shadow: 0 0 0 2px
        color-mix(in oklch, ${colors.primary ?? '#88f'} 40%, transparent);
    `}
`;

export const InitialsText = styled.span<{ $size: number }>`
  font-weight: 600;
  letter-spacing: 0.02em;
  user-select: none;
  pointer-events: none;

  ${({ $size }) => {
    const fontSize = Math.max(10, Math.round($size * 0.36));
    return css`
      font-size: ${fontSize}px;
    `;
  }}

  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurface ?? '#fff'};
  `}
`;

export const StatusDot = styled.span<{ $status: AvatarStatus }>`
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 8px;
  height: 8px;
  border-radius: 50%;

  ${({ $status, theme: { colors = {} } }) => css`
    background-color: ${STATUS_COLORS[$status] ?? STATUS_COLORS[AVATAR_STATUS_ONLINE]};
    border: 2px solid ${colors.surface ?? colors.surfaceContainer ?? '#000'};
  `}
`;
